import {
  wholesaleV2 as ApiWholesaleV2Service,
  wholesaleV2withMgr as ApiwholesaleV2withMgrService,
  wholesaleV2withAccount as wholesaleV2withAccountService
} from './ApiService';

const CURRENT_CUSTOMER_LS_KEY = '__current_customer__';
const ACTIVE_CURRENCY_LS_KEY = '__currency__'

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function parseCurrentCustomerFromLS() {
  const rawCustomer = localStorage.getItem(CURRENT_CUSTOMER_LS_KEY);

  if (!rawCustomer) {
    return null;
  }

  try {
    return JSON.parse(rawCustomer);
  } catch (error) {
    console.error('Failed to parse current customer from localStorage.', error);
    return null;
  }
}

export function setCurrentCustomerToLS(customer) {
  localStorage.setItem(CURRENT_CUSTOMER_LS_KEY, JSON.stringify(customer));
}

export function removeCurrentCustomerFromLS() {
  localStorage.removeItem(CURRENT_CUSTOMER_LS_KEY);
}

export function isValidCurrentCustomer(customer) {
  return isPlainObject(customer)
    && Object.keys(customer).length > 0
    && customer.id !== undefined
    && customer.id !== null;
}

export function resolveCurrentCustomer(customerCandidate) {
  const candidates = [
    customerCandidate,
    customerCandidate?.payload,
    customerCandidate?.data,
    customerCandidate?.value,
  ];

  return candidates.find((candidate) => isValidCurrentCustomer(candidate)) || null;
}

export function getCurrentCustomerFromLSOrNull() {
  return resolveCurrentCustomer(parseCurrentCustomerFromLS());
}

export function getCurrentCustomerFromLS() {
  return getCurrentCustomerFromLSOrNull() || {};
}

export function getActiveCurrencyFromLS() {
  const currency = localStorage.getItem(ACTIVE_CURRENCY_LS_KEY);
  if (!currency) {
    localStorage.setItem(ACTIVE_CURRENCY_LS_KEY, "EUR");
    return "EUR";
  }
  return currency;
}

export function setActiveCurrencyToLS(currency) {
  localStorage.setItem(ACTIVE_CURRENCY_LS_KEY, currency);
}

export default {
  fetchCustomers() {
    return ApiwholesaleV2withMgrService.accessGet('/customers');
  },

  fetchCustomersSelected() {
    return ApiwholesaleV2withMgrService.accessGet('/customers/selected');
  },

  fetchCustomersSettings() {
    return ApiwholesaleV2withMgrService.accessGet('/user/settings');
  },

  changeCustomersSettings(data) {
    return ApiwholesaleV2withMgrService.accessPut('/user/settings', data);
  },

  fetchAccountData() {
    return wholesaleV2withAccountService.accessGet('/details');
  },

  setCustomerCreditLimit(data) {
    return ApiwholesaleV2withMgrService.patch('/customer/creditlimit', data)
  },

  setCustomerSelfApproval(customerId, selfApproval) {
    console.log(`selfApproval`, selfApproval)
    return ApiwholesaleV2withMgrService.accessPut(
      `/customers/${customerId}/params/selfapproval`,
      selfApproval.toString()
    );
  },

  setCustomerSelfApprovedOrderLimit(customerId, selfApprovedOrderLimit) {
    return ApiwholesaleV2withMgrService.accessPut(
      `/customers/${customerId}/params/selfapprovedorderlimit`,
      selfApprovedOrderLimit
    );
  }
};
